module.exports = __webpack_public_path__ + "img/download-icon-dark.be38a4ee.svg";